/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block}label[_ngcontent-%COMP%]{font-weight:600;font-size:.9em}"];
export { styles as styles };
